// This file contains constants related to the game dice assets.

export const DICE_IMAGE_SCALE = 0.7;
